import { http } from "../http-common";

const postImage = (data: FormData, code: string) => {
    return http.post<any>(`/images`, data, {
        params: { code },
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const getImage = (id: any) => {
    return http.get<any>(`/images/${id}`);
};

const ImageService = {
    postImage,
    getImage,
};

export default ImageService;
